export default __webpack_public_path__ + "static/ApercuLAPhil-Medium-c74ce51a49ccba7bcf42a97724559e74.woff2";